<template>
  <section class="flex items-start gap-x-4 text-sm md:mx-4 md:py-4 <md:p-4 ">
    <slot />
    <div class="f-col grow gap-6 between wrap md:flex-row md:gap-4" :class="classWrapper">
      <ul class="f-col gap-6 wrap md:flex-row md:gap-4 md:!gap-3">
        <li class="md:hidden">
          <vf-location-selector>| {{ $t.changeCountry }}</vf-location-selector>
        </li>
        <li v-for="({ title, to, icon }, i) in links" :key="i">
          <base-link
            class="hover:underlined"
            :class="{ 'flex items-center gap-x-1 ': icon }"
            :to
          >
            <vf-icon v-if="icon" class="-my-4 c-brand-4" :name="icon" size="lg" />
            {{ title }}
          </base-link>
        </li>
      </ul>
      <slot name="right" />
    </div>
    <vf-location-selector class="ml-8 shrink-0 <md:hidden !ml-0">
      | {{ $t.changeCountry }}
    </vf-location-selector>
  </section>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'
import type { NavigationLink } from '#types/navigation'

defineProps<{
  /**
   * Legal links to display
   */
  links: NavigationLink[]
  /**
   * Defines classList of the wrapper div around the links
   */
  classWrapper?: CSSClass
}>()
</script>
